import { GobernanzaSessionService } from "@modules/gobernanza/services/gobernanza-session.service";

import { inject } from "@angular/core";
import { type CanActivateFn, Router } from "@angular/router";

export const gobernanzaAccessGuard: CanActivateFn = () => {
  const sessionService = inject(GobernanzaSessionService);
  const router = inject(Router);

  if (sessionService.isAuthenticated()) {
    return true;
  }

  return router.parseUrl("/login-gobernanza");
};
